import createNativeActivityBridge from './nativeActivityBridge'

// Live Activity (iOS lock screen + Dynamic Island) / ongoing notification
// (Android) mirroring the recording screen. Exposes isAvailable, isSupported,
// start, update, end.
export default createNativeActivityBridge('LiveActivity', { stopMethod: 'end' })
